import { Box, Button, Stack } from '@mantine/core';
import { useTheme } from '@emotion/react';

import dt from '~/testing';
import { Text } from '~/domains/common/components/Text/Text';
import { IconStarFilled } from '~/domains/common/components/icons/IconStarFilled';

import usePickStyles from './GamePick.styles';
import GamePickImage from './GamePickImage';

type GamePickProps = {
  onGameClick?: (id: string) => void;
  teamId?: string;
  name?: string;
  teamAlias?: string;
  logo?: string;
  isWinning?: boolean;
  isBestPick?: boolean;
  label?: string;
  shouldMakePicks?: boolean;
};

export function GamePick({
  onGameClick,
  teamId,
  name,
  teamAlias,
  logo,
  isWinning,
  isBestPick,
  label,
  shouldMakePicks,
}: GamePickProps) {
  const theme = useTheme();

  const { classes } = usePickStyles({
    isWinning,
    shouldMakePicks,
  });

  const handlePickClick = (uuid: string): void => {
    if (onGameClick) {
      onGameClick(uuid);
    }
  };

  return (
    <Button
      data-test-id={dt.contestDetail.section.myEntries.row.team.button}
      classNames={classes}
      miw={70}
      radius={theme.radius.sm}
      h="100%"
      onClick={() => {
        handlePickClick(teamId);
      }}
    >
      <Stack className={classes.stack} spacing={theme.spacing.sm / 3}>
        <Box className={classes.imageContainer}>
          {isBestPick && (
            <IconStarFilled
              data-test-id={dt.contestDetail.section.myEntries.row.team.bestPickIcon}
              size={14}
              className={classes.bestPickStar}
            />
          )}
          <Stack justify="center" align="center" spacing={0}>
            <GamePickImage shouldMakePicks={shouldMakePicks} key={teamId} name={name} logo={logo} />
            <Text
              data-test-id={dt.contestDetail.section.myEntries.row.team.abbreviationText}
              variant="web-label-x-small"
              color={theme.colors.dark[8]}
            >
              {teamAlias}
            </Text>
          </Stack>
        </Box>
        <Text
          transform="uppercase"
          fz={theme.fontSizes.xs}
          fw={400}
          c={shouldMakePicks ? theme.colors.red[6] : theme.black}
          ta="center"
        >
          {label || 'G'}
        </Text>
      </Stack>
    </Button>
  );
}
